import { UpdateBonusPayrollRequestInterface } from "@/data/payload/contracts/PayrollBonusRequest";
import { PayrollBonusRepositoryInterface } from "@/data/persistences/repositories/contracts/PayrollBonusRepositoryInterface";
import { Report } from "@/domain/entities/Main";
import { Bonus, BonusPayrolls } from "@/domain/entities/PayrollBonus";
import { injectable } from "tsyringe";

@injectable()
export class PayrollBonusPresenter implements PayrollBonusRepositoryInterface {
  private repository: PayrollBonusRepositoryInterface

  constructor(repository: PayrollBonusRepositoryInterface) {
    this.repository = repository
  }

  public getBonus(params: Map<string, string | number>): Promise<BonusPayrolls> {
    return this.repository.getBonus(params)
  }

  public get(id: string): Promise<Bonus> {
    return this.repository.get(id)
  }

  public export(): Promise<Report> {
    return this.repository.export()
  }
  
  public update( payload: UpdateBonusPayrollRequestInterface): Promise<boolean> {
    return this.repository.update(payload)
  }

  public recalculateBonus(params: Map<string, string | number>): Promise<boolean> {
    return this.repository.recalculateBonus(params)
  }
}
